import { AccordionSummaryWrapper } from './AccordionSummaryWrapper';

export default AccordionSummaryWrapper;
